<template>
  <view>
    <!-- <es-face></es-face> -->
    <es-popup show="{{showPopup}}" align="center" class="es-custom-class" bind:overlay-click="overlayClickHandle">
      <view class="es-rm-container-code" wx:if="{{typeCode10602Dx}}">
        <!-- <es-icon name="exclamation-circle-filled" class="exclamation-circle-filled" size="60" /> -->
        <text class="es-conent-text">短信验证</text>
        <text class="es-conent-text-p">{{ smsCheckNotice }}</text>
        <view class="es-code-button" bindtap="onClickMessageCode">去核验</view>
      </view>
      <view class="es-rm-container" wx:if="{{typeCode10603}}">
        <image
          class="es-rm-image"
          wx:style="width: 100px; height: 100px;"
          src="https://pt-starimg.didistatic.com/static/starimg/img/DWtxBxZakm1641959558379.png"
        ></image>
        <text class="es-rm-text">{{ rmText }}</text>
        <view>
          <view class="buttonStyle" bindtap="onClickFace">
            <text wx:if="{{__mpx_mode__ !== 'web'}}">同意协议并人证核验</text>
            <text wx:else>同意协议并人证核验</text>
          </view>
        </view>
        <view wx:if="{{typeCode10602 && !cxvipVerify}}">
          <view class="buttonStyleNone" bindtap="onClickMessage">无法刷脸，通过短信核验</view>
        </view>
        <es-shake shake="{{shake}}">
          <view class="es-rm-agree-box">
            <view class="es-rm-agreement">
              <es-checkbox-group wx:model="{{checkboxValue}}" direction="row">
                <es-checkbox
                  label-position="right"
                  name="1"
                  shap="round"
                  iconSize="{{16}}"
                  icon-style="{{{borderRadius: '4px'}}}"
                >
                  <text class="es-rm-checkbox">勾选表示已阅读并同意</text></es-checkbox
                >
              </es-checkbox-group>
            </view>
            <view
              bindtap="goto"
              class="es-rm-navigator es-rm-navigator-hover"
              hover-class="navigator-hover"
              >服务协议、认证协议</view
            >
          </view>
        </es-shake>
      </view>
    </es-popup>
  </view>
  <!-- 
'10602': // 为保障您的账号安全，需进行短信核验后才能继续登录购票
'10603': // 为保障您的账号安全，需进行人证核验后才能继续登录购票   
'10607': // 为保障您的账号安全，需进行人证核验或人脸核验后才能继续登录购票
   -->
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import store from '@/store'
  import { innerRouter, pagePath } from "@/common/jump";
  import { trackEvent } from '@/common/track'
  createComponent({
    props: {
      code: [Object, String],
      codeData: [Object],
      loginType: {
        type: String,
        value: ''
      },
      tickets12306: {
        type: Boolean,
        value: false
      }
    },
    data: {
      checkboxValue: [],
      shake: false
    },
    computed: {
      ...store.mapState({
        userInfo12306: 'login12306.userInfo12306',
        cxvipVerify: 'login12306.cxvipVerify',
        fullPath: 'login12306.fullPath',
        showVerification: 'tickets12306.showVerification'
      }),
      smsCheckNotice() {
        return this.tickets12306 ? '为保障您的帐号安全，需要进行短信核验后才能查看本人车票' : this.userInfo12306.message
      },
      typeCode10602Dx() {
        return ['10602'].includes(this.userInfo12306?.code)
      },
      typeCode10603() {
        // 为保障您的账号安全，需进行人证核验后才能继续登录购票
        const type = ['10603', '10607'].includes(this.userInfo12306?.code) || this.cxvipVerify || this.showVerification
        return type
      },
      typeCode10602() {
        // 为保障您的账号安全，需进行短信核验后才能继续登录购票
        const type = ['10607'].includes(this.userInfo12306?.code)
        return type
      },
      showPopup() {
        const type = ['10602', '10607', '10603'].includes(this.userInfo12306?.code) || this.cxvipVerify || this.showVerification
        return type
      },
      rmText() {
        if(this.showVerification) return '为保障您的帐号安全，需要进行人证核验后才能查看本人车票'
        return this.cxvipVerify
          ? '为保障您的帐号安全，需要进行人证核验后才能激活畅行会员'
          : '为保障您的帐号安全，需要进行人证核验后才能继续登录购票'
      }
    },

    watch: {
      checkboxValue: {
        handler(val, old) {
          if (val === old) {
            return
          }
        }
      },
      showPopup: {
        handler(val, old) {
          if (val === old) {
            return
          }
          if(!val) {
            this.checkboxValue = []
          }else{
            trackEvent('userteam_train_12306land_pop_sw', 'UT-火车票-12306登陆-弹窗-曝光',{
              type: this.userInfo12306?.code
            })
          }

        }

      }
    },

    methods: {
      ...store.mapMutations({
        setChangeCode: 'login12306.setChangeCode',
        verifyCxvip: 'login12306.verifyCxvip',
        backPageUrlMutation: 'login12306.backPageUrlMutation',
        setShowVerification: 'tickets12306.setShowVerification',
        setShowLoginDrawer: 'login12306.setShowLoginDrawer',
      }),
      overlayClickHandle() {
        this.cxvipVerify && this.verifyCxvip(false)
        this.showVerification && this.setShowVerification(false)
      },
      async goto() {
        let goToUrl = 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2\u0026policy_id=50072334'
        innerRouter.goTo(goToUrl)
      },
      trackEventCK(params){
        trackEvent('userteam_train_12306land_pop_ck','UT-火车票-12306登陆-弹窗-点击',{
          type: this.userInfo12306?.code,
          ...params
          })
      },
      onClickFace() {
        const trackParams = {
          module:'face',
          is_success:1
        }
        const that = this
        if (!this.checkboxValue.length) {
          trackParams.is_success = 0
          this.trackEventCK(trackParams)
          mpx.showToast({
            title: '请先勾选“服务协议、认证协议”',
            icon: 'error'
          })
          this.shake = true
          setTimeout(() => {
            this.shake = false
          }, 800)
          return false
        }
        this.trackEventCK(trackParams)
        let isSmsCode = 3
        if(this.cxvipVerify) {
          this.verifyCxvip(false)
          isSmsCode = 4
        }
        this.showVerification && this.setShowVerification(false)
        this.setChangeCode({ code: null, isSmsCode })
        // innerRouter.push(pagePath().WITNESSVERIFICATION)
        if (__mpx_mode__ !== 'web') {
          wx.getSetting({
            success(res) {
              console.log(res, '权限问题')
              if (!res.authSetting['scope.camera']) {
                wx.authorize({
                  scope: 'scope.camera',
                  success() {
                    innerRouter.push(pagePath().WITNESSVERIFICATION)
                  },
                  fail() {
                    // mpx.showToast({
                    //   title: '未授权',
                    //   icon: 'error',
                    //   success: res => {}
                    // })
                  }
                })
              } else {
                innerRouter.push(pagePath().WITNESSVERIFICATION)
              }
            }
          })
        } else {
          const from = this.tickets12306 ? 'tickets12306' : ''
          innerRouter.push(pagePath().WITNESSVERIFICATION, { from })
        }
      },
      onClickMessageCode() {
        // 风控弹窗关闭
        this.trackEventCK({
          module:'msg',
          is_success:1
        })
        this.setShowLoginDrawer(false)
        this.setChangeCode({ code: null, isSmsCode: 1 })
        innerRouter.push(pagePath().VERIFICATIONCODE, {
          loginType: this.loginType,
          from: this.tickets12306 ? 'tickets12306' : '',
        })
      },
      onClickMessage() {
        const trackParams = {
          module:'meg',
          is_success:1
        }
        if (!this.checkboxValue.length) {
          trackParams.is_success = 0
          this.trackEventCK(trackParams)
          mpx.showToast({
            title: '请先勾选“服务协议、认证协议”',
            icon: 'error'
          })
          this.shake = true
          setTimeout(() => {
            this.shake = false
          }, 800)
          return false
        }
        this.trackEventCK(trackParams)
        this.onClickMessageCode()
      }
    },

    beforeCreate() {},

    created() {},
    mounted() {
      const fullPaths = this.$mpxRoute?.fullPath || this.fullPath
      // isError
      const isError = fullPaths?.indexOf('isError') > -1
      if (!isError) {
        // 如果url上面有isError 就不存储了
        // setStorage({ key: 'backPageUrl', data: fullPaths })
        this.backPageUrlMutation(fullPaths)
      }
    },
    // 销毁
    destroyed() {
      this.setChangeCode({ code: null })
    }
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-rm-container
    width 290px
    min-height 311px
    background #E2EEFF
    background linear-gradient(to bottom, #E2EEFF, #ffffff)
    border-radius 4px
    display inline-block
  .es-rm-container-code
    width 290px
    background #ffffff
    // background linear-gradient(to bottom, #E2EEFF, #ffffff)
    border-radius 4px
    display inline-block
    padding 10px 0px
  .es-rm-image
    margin 30px auto 0px auto
    display block
  .es-rm-agree-box
    display flex
  .es-rm-text
    padding 27px 16px 0px
    display block
    font-size 15px
    line-height 21px
  .buttonStyle
    margin-top 24px
    color white
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
  .buttonStyleNone
    margin-top 24px
    color $train-color-theme-blue
    background $train-color-fff
    font-size 16px
    border 1px #1473FF solid
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
  .es-rm-agree-box
    padding 0px 10px 16px 10px
  .es-rm-checkbox
    font-size 13px
    color $train-color-999
    margin-left -5px
  .es-rm-navigator
    font-size 12px !important
    line-height 23px
    color $train-color-theme-blue
  .es-code-button
    color $train-color-theme-blue
    font-size 16px
    text-align center
    padding 10px 0px
    border-top 1px $train-color-eee solid
  .es-conent-text
    padding 15px 0px 10px 0px
    display block
    font-size 16px
    text-align center
  .es-conent-text-p
    padding 0px 30px 20px 30px
    display block
    font-size 14px
    color $train-color-999
  .exclamation-circle-filled
    color $train-color-theme-blue
  .es-rm-navigator
    font-size 13px !important
    line-height 20px
    display block
    color $train-color-theme-blue
    text-decoration none
  .es-rm-navigator-hover
    color #506482
</style>
<script name='json'>
  const config = {
    // navigationBarTitleText: '风控',
    component: true,
    usingComponents: {
      'es-face': '../face',
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'es-checkbox': '@/es-mpx-ui/lib/checkbox',
      'es-checkbox-group': '@/es-mpx-ui/lib/checkbox-group',
      'es-shake': '@/components/transition-shake',
      'es-icon': '@didi/es-mpx-ui/lib/icon'
    }
  }
  module.exports = config
</script>

